import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IOpenerService } from 'vscode/vscode/vs/platform/opener/common/opener.service';
import { IBrowserWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/browser/environmentService.service';

let ExternalUriResolverContribution = class ExternalUriResolverContribution extends Disposable {
    static { this.ID = 'workbench.contrib.externalUriResolver'; }
    constructor(_openerService, _workbenchEnvironmentService) {
        super();
        if (_workbenchEnvironmentService.options?.resolveExternalUri) {
            this._register(_openerService.registerExternalUriResolver({
                resolveExternalUri: async (resource) => {
                    return {
                        resolved: await _workbenchEnvironmentService.options.resolveExternalUri(resource),
                        dispose: () => {
                        }
                    };
                }
            }));
        }
    }
};
ExternalUriResolverContribution = ( __decorate([
    ( __param(0, IOpenerService)),
    ( __param(1, IBrowserWorkbenchEnvironmentService))
], ExternalUriResolverContribution));

export { ExternalUriResolverContribution };
